import clsx from "clsx";
import Link from "next/link";
import type { FC } from "react";
import { THESIS_ITEM_TYPE_ID } from "utils";
import { slugMaker } from "utils/normalizer";

interface IProps {
  itemId: string;
  itemTypeId: number,
  title: string;
  authorStatement: string;
  branch: string;
  major: string;
  degree: string;
  defencDate: string;
  supervisor: string[];
  consultor: string[];
}

const ThesItemPayamLib: FC<IProps> = ({
  itemId,
  itemTypeId,
  title,
  authorStatement,
  branch,
  major,
  degree,
  defencDate,
  supervisor,
  consultor,
}) => {
  return (
    <div className="tw-rounded-lg tw-p-5 xxxl:tw-p-[26.67px] tw-border tw-border-solid tw-border-[#344456]/20 tw-bg-[#FFFFFF]">
      <Link
        href={`/thesis-details/${itemTypeId}/${itemId}/${encodeURIComponent(
          slugMaker(title, 60)
        )}`}
      >
        <a className="tw-text-[13px] xxxl:tw-text-[17.33px] tw-font-bold tw-min-h-[66px] tw-mb-2 tw-block hover:tw-text-primary-main" dir={itemTypeId != THESIS_ITEM_TYPE_ID?.FA ? "ltr" : "rtl"}>
          {title}
        </a>
      </Link>
      <div>
        {[
          { label: "دانشجو", value: authorStatement },
          { label: "استاد مشاور", value: consultor.join("، ") },
          {
            label: "رشته / گرایش",
            value: major ? `${branch} - ${major}` : branch,
          },
          { label: "مقطع تحصیلی", value: degree },
          {
            label: "استاد راهنما/استاد راهنما همکار",
            value: supervisor.join("، "),
          },
          {
            label: "سال دفاع",
            value: defencDate,
          },
        ].map((item, i) => (
          <div
            className={clsx(
              "tw-py-2.5 tw-px-4 tw-flex tw-justify-between tw-items-center",
              { "tw-bg-[#F6F7FB]": i % 2 === 0 }
            )}
            key={i}
          >
            <div className="tw-text-[#344456]/60 tw-text-[14px] xxxl:tw-text-[17.33px]">
              {item.label}:
            </div>
            <div className="tw-text-[#344456] tw-text-[13px] xxxl:tw-text-base tw-font-[500] tw-text-left">
              {item.value || "-"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThesItemPayamLib;
